// extracted by mini-css-extract-plugin
module.exports = {"draftSelector":"draft-selector__draftSelector--15QWc"};